import React from "react";
import ChooseOrderTypeButton from "../../../Widgets/ChooseOrderTypeButton";
import OrderTypeHeader from "../../../Widgets/OrderTypeHeader/OrderTypeHeader";
import {
  changeOrderType,
  isCollectionDrawerOpen,
} from "../../reducer/PaymentActions";
import { IOrderTypesChildren, SelectedOrderType } from "../../types.d";
import { ReactComponent as CollectionBagSVG } from "../../../../imges/CollectionBag.svg";
import { YellowColorCodeForOrderTypeSvgs } from "../OrderTypesComponent";

export function CollectionsType({
  dispatch,
  orderType,
  selectedTime,
}: IOrderTypesChildren) {
  return (
    <div>
      <OrderTypeHeader
        title="Payment.Collection"
        svgImage={<CollectionBagSVG fill={YellowColorCodeForOrderTypeSvgs} />}
        selected={true}
      />

      <ChooseOrderTypeButton
        key={"collect"}
        title={"SelectCollectionTime"}
        ETA={
          selectedTime !== null && orderType === SelectedOrderType.CLICK
            ? selectedTime
            : null
        }
        onClick={() => {
          dispatch(changeOrderType(SelectedOrderType.CLICK));
          dispatch(isCollectionDrawerOpen(true));
        }}
        selected={
          selectedTime !== null && orderType === SelectedOrderType.CLICK
        }
        dataComponentName="Collect"
      />
    </div>
  );
}
